import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';

import Loading from 'shared/components/Loading';
import PurchaseDetails from 'app/components/PurchaseDetails';
import messages, { FormattedMessage, withValues } from 'shared/messages/messages';
import config from 'shared/config/config';

import {
  newOrder,
  logout
} from 'app/actions/kioskActions';

import {
  getPurchases
} from 'shared/actions/cartActions';

import {
  trackEvent
} from 'shared/services/Analytics';

import {
  CLUB_MED_LOGIN_TYPE,
  SINGLE_PANE_RECEIPT_SCREEN_TYPE,
  DOUBLE_PANE_RECEIPT_SCREEN_TYPE,
  KIOSK_BACKGROUND_URL
} from 'app/utils/Constants';

import {
  HPX_THEME
} from 'shared/config/themes';

const styles = () => ({
  container: {
    width: '100%',
    maxWidth: '44rem',
    display: 'block',
    margin: '5rem auto 0',
    textAlign: 'left',
  },
  container2: {
    position: 'fixed',
    display: 'block',
    width: '100%',
    height: '100%',
    background: config.kiosk_bg_color,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover'
  },
  col: {
    display: 'inline-block',
    width: '50%',
    float: 'left'
  },
  form: {
    width: '500px',
    maxWidth: '90%',
    margin: '7rem auto 0',
    padding: '2rem',
    border: '5px solid ' + config.kiosk_form_border_color,
    borderRadius: '8px',
    boxShadow: '0 0 3px rgba(0, 0, 0, 0.5)',
    background: config.kiosk_form_bg_color
  },
  header: {
    fontSize: '1.5rem',
    fontWeight: 700,
    fontFamily: config.main_font
  },
  message: {
    fontSize: '16px',
    color: config.kiosk_form_message_font_color,
    fontFamily: config.sub_font
  },
  buttons: {
    float: 'left',
    marginTop: '1rem',
    paddingRight: '4rem',
    width: '100%'
  },
  button: {
    float: 'left',
    width: '100%',
    marginBottom: '1rem',
    padding: '0.3rem 1rem',
    textAlign: 'center',
    fontSize: '1rem',
    fontWeight: 600,
    background: 'linear-gradient(#4ea4c3, #007aa1)',
    borderRadius: '3px',
    border: 'none',
    color: '#fff',
    boxShadow: '0 0 2px #dcdcdc',
    fontFamily: config.root_font_family
  },
  secondButton: {
    float: 'left',
    width: '100%',
    marginBottom: '1rem',
    padding: '0.3rem 1rem',
    textAlign: 'center',
    fontSize: '1rem',
    fontWeight: 600,
    background: 'linear-gradient(#ffffff, #f1f1f1)',
    border: '1px solid #dcdcdc',
    borderRadius: '3px',
    boxShadow: '0 0 2px #dcdcdc',
    color: '#2b8eb0',
    fontFamily: config.root_font_family
  },
  button2: {
    background: config.kiosk_modal_button_action_bg_color,
    color: config.kiosk_modal_button_action_font_color,
    margin: '1em 0.5rem 0',
    border: '1px solid ' + config.kiosk_logout_btn_bg,
    padding: '0.7rem 1rem',
    textAlign: 'center',
    borderRadius: '3px',
    fontWeight: 'bold',
    fontFamily: config.root_font_family
  }
});

class Receipt extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true
    }
  }

  componentDidMount() {
    this.loadPurchases()
      .then(() => this.setState({ loading: false }));
  }

  async loadPurchases() {
    const { user, purchases, getPurchases } = this.props;

    if (!purchases.length) {
      await getPurchases(user.story_id);
    }
  }

  logout() {
    const { settings, user } = this.props;

    this.props.logout()
      .then(() => {
        trackEvent('Kiosk.Logout', {
          userId: user.id,
          storyId: user.story_id,
          kiosk: settings.token
        });
      });
  }

  renderSinglePane() {
    const { classes, settings, user, email, locale } = this.props;

    let backgroundStyle = { backgroundImage: `url(${KIOSK_BACKGROUND_URL(settings.token, locale)})` }

    let galleryBtnLabel;
    if (user.unlocked) {
      galleryBtnLabel = messages.button_view_gallery;
    } else {
      // need translation for "New Order" before use
      //galleryBtnLabel = messages.button_new_order;
      galleryBtnLabel = messages.button_buy_more;
    }

    return (
      <div className={classes.container2} style={backgroundStyle}>
        <form className={classes.form}>
          <p className={classes.header}>
            <FormattedMessage {...messages.kiosk_receipt_header} />
          </p>
          <p className={classes.message}>
            <FormattedMessage {...withValues(messages.kiosk_receipt_instructions, { email })} />
          </p>
          <br />
          <br />
          <PurchaseDetails complete={true} />
          {
            !settings.hide_buy_more &&
            <button className={classes.button2} onClick={() => this.props.newOrder()}>
              <FormattedMessage {...galleryBtnLabel} />
            </button>
          }
        </form>
      </div>
    );
  }

  renderDoublePane() {
    const { classes, settings, user, email } = this.props;

    let galleryBtnLabel;
    if (user.unlocked) {
      galleryBtnLabel = messages.button_view_gallery;
    } else {
      // need translation for "New Order" before use
      //galleryBtnLabel = messages.button_new_order;
      galleryBtnLabel = messages.button_buy_more;
    }

    // if clubmed login type then show Send Links button.
    // this shows a modal listing guests in the room
    let clubMedSendLinksBtn = null;
    if (settings.login_type === CLUB_MED_LOGIN_TYPE) {
      clubMedSendLinksBtn = (
        <button className={classes.secondButton} onClick={() => window.topbar.showRoomDialog()}>
          <FormattedMessage {...messages.button_send_links} />
        </button>
      );
    }

    return (
      <div className={classes.container}>
        <div className={classes.col}>
          <p className={classes.header}>
            <FormattedMessage {...messages.kiosk_receipt_header} />
          </p>
          <p className={classes.message}>
            <FormattedMessage {...withValues(messages.kiosk_receipt_instructions, { email })} />
          </p>
          <div className={classes.buttons}>
            {
              !settings.hide_buy_more &&
              <button className={classes.button} onClick={() => this.props.newOrder()}>
                <FormattedMessage {...galleryBtnLabel} />
              </button>
            }
            {clubMedSendLinksBtn}
            <button className={classes.secondButton} onClick={() => this.logout()}>
              <FormattedMessage {...messages.button_log_out} />
            </button>
          </div>
        </div>
        <div className={classes.col} style={{ paddingTop: '0.3rem', background: '#eee', padding: '1rem', borderRadius: '5px' }}>
          <PurchaseDetails complete={true} />
        </div>
      </div>
    );
  }

  render() {
    if (this.state.loading) {
      return (<Loading />);
    }

    const { settings } = this.props;

    switch (settings.receipt_screen_type) {
      case SINGLE_PANE_RECEIPT_SCREEN_TYPE:
        return this.renderSinglePane();

      case DOUBLE_PANE_RECEIPT_SCREEN_TYPE:
      default:
        return this.renderDoublePane();
    }
  }
}

const mapStateToProps = state => ({
  settings: state.kioskReducer.settings,
  email: state.kioskReducer.email,
  user: state.kioskReducer.user,
  view: state.kioskReducer.view,
  locale: state.messagesReducer.locale,
  loggedIn: state.kioskReducer.loggedIn,
  purchases: state.cartReducer.purchases
});

export default connect(mapStateToProps, { newOrder, logout, getPurchases })(withStyles(styles)(Receipt));
